"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION_NUMBER = exports.VERSION = void 0;
// THIS IS AN AUTO GENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
exports.VERSION = '2.0.1';
exports.VERSION_NUMBER = 200001000;
